import { AbstractModel } from "@gipi-pages/abstract/models/abstract.model";

export class NotificationTypeModel extends AbstractModel {

    description: string;

    imageUrl: string;

}
